import React, { Component } from 'react';
import axios from "axios";
import api from "./../../../../services/api";
import './style.css';
import { NavLink } from 'react-router-dom';
import ConsultaHoje from './ConsultaHoje';
import GetNumeric from './GetName';
//import GetName from './GetName';

//import da API
import { professional } from './../../../../services/api';
let apiProfessional = new professional();

var token = localStorage.getItem('user_token');
var medico_id = localStorage.getItem('professional_id');

//Classe para API
export default class DataExam extends Component {
  state = {
    exames: [],
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    // const request = await api.get(`/exam/professional/${medico_id}?status=Confirmada`, {headers: {'x-access-token': token}});
    const request = await apiProfessional.getAllProfessionalExams(medico_id, [{ header: 'status', value: 'Confirmada' }]);
    //const request = await axios.get(`http://localhost:5000/professional/exam/professional/5f1b15741bc7d6adc74da81d?status=Confirmada`, { headers: { 'x-access-token': token } });
    console.log(request);
    console.log(request.data);
    this.setState({ exames: request.data });

  };

  render() {
    return (
      <>
        <div id="lista-style">

          {this.state.exames.map(exam => (
            <>
              <NavLink to={{ pathname: '/tela_ps_cc/' + exam._id }}>
                <ConsultaHoje data={exam.appointment_date} consulta={exam.appointment_type} user_id={exam.user_id} />
              </NavLink>
            </>
          ))}
        </div>
      </>

    );
  }

}
